import { connectorApiClient } from '@/shared/api/core/axios-instance';

import type { ConnectorTypeSchema } from '@/entities/connector/types';

export const getConnectorTypeSchemaApi = async (type: string): Promise<ConnectorTypeSchema> => {
  const { data } = await connectorApiClient.get<ConnectorTypeSchema>(`/connector-types/${type}/schema`);
  return data;
};
